// useCategories.ts
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { queryKeys } from "./queryKeys";
import CategorieService from "@/integrations/service/categorie.service";

export const useCategories = () => {
  return useQuery({
    queryKey: queryKeys.categories,
    queryFn: CategorieService.getAll,
  });
};

export const useCreateCategory = () => {
  const qc = useQueryClient();

  return useMutation({
    mutationFn: CategorieService.create,
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: queryKeys.categories });
    },
  });
};

export const useUpdateCategory = () => {
  const qc = useQueryClient();

  return useMutation({
    mutationFn: ({ id, payload }: any) =>
      CategorieService.update(id, payload),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: queryKeys.categories });
    },
  });
};

export const useDeleteCategory = () => {
  const qc = useQueryClient();

  return useMutation({
    mutationFn: CategorieService.delete,
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: queryKeys.categories });
    },
  });
};